/* RESPONSIBLE TEAM: team-ai-agent */

import type BotIntroLocalization from 'embercom/models/operator/bot-intro/localization';

/**
 * Determines if a bot intro localization is using default parts by comparing current and default parts
 * @param localization The bot intro localization to check
 * @returns boolean indicating if the localization is using default parts
 */
export function isUsingDefaultParts(localization: BotIntroLocalization): boolean {
  let currentParts = (localization.parts || []).map((part) => part.jsonBlocks?.toArray?.() ?? []);
  let defaultParts = (localization.defaultParts || []).map(
    (part) => part.jsonBlocks?.toArray?.() ?? [],
  );
  return JSON.stringify(currentParts) === JSON.stringify(defaultParts);
}

/**
 * Updates the usingDefault flag for all bot intro localizations
 * @param localizations Array of bot intro localizations to update
 */
export function updateUsingDefaultFlags(localizations: BotIntroLocalization[]): void {
  localizations.forEach((localization) => {
    localization.usingDefault = isUsingDefaultParts(localization);
  });
}
